  export const spectreOptions = [ 
    { name: 'Mes sites', value: 'mesSites' },
    { name: 'Cobra', value: 'siegeKin' }
  ];

  export const parOptions = [ 
    { name: 'Sites', value: 'sites' },
    { name: 'Véhicule', value: 'vehicule' }
  ];

 export const periodeOptions = [ 
    { name: '7 jours', value: '7jours' },
    { name: '30 jours', value: '30jours' },
    { name: '90 jours', value: '90jours' },
    { name: '180 jours', value: '180jours' },
    { name: '360 jours', value: '360jours' }
  ];
